export * from "-!../../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./UiAsyncSelect.vue?vue&type=template&id=4c48a7e7&"


//////////////////
// WEBPACK FOOTER
// ./src/modules/shared/ui/public/forms/fields/UiAsyncSelect.vue?vue&type=template&id=4c48a7e7&
// module id = 1123
// module chunks = 0